import React from 'react';

import Change from '../../../components/Change/Change';
import { formatNumber } from '../../../core/helpers/format-number';

import { TableCol5ChangeModel } from '../../../core/models/tables';

interface ILngPricesTable {
  date1: string;
  date2: string;
  rows: TableCol5ChangeModel[];
  units: string;
}

export default function LngPricesTable({
  date1,
  date2,
  rows,
  units,
}: ILngPricesTable): JSX.Element {
  return (
    <div className="table-container">
      <table className="total-table total-table-stripped table-sm">
        <thead>
          <tr>
            <th>{units}</th>
            <th>{date1}</th>
            <th>{date2}</th>
            <th>
              Change <br /> D-1 vs D-2
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((price, index) => (
            <tr key={index}>
              <td>{formatNumber(price.col1)}</td>
              <td>{formatNumber(price.col2)}</td>
              <td>{formatNumber(price.col3)}</td>
              <td>
                <Change value={price.col4} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <p className="note">Note: Indicative Market Level Index</p>
    </div>
  );
}
